<template>
  <a :class="classString" data-toggle="tab" :href="'#tab-' + cardIndex">
    <h4>{{ title }}</h4>
    <p><slot /></p>
    <button
      :id="'promotionCardButton' + cardIndex"
      type="submit"
      class="nav-link btn btn-default"
      @click="download(imagePath, fileName)"
    >
      <svg
        width="1.7em"
        height="1.7em"
        viewBox="0 0 16 16"
        class="bi bi-download"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
        />
        <path
          fill-rule="evenodd"
          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
        />
      </svg>
    </button>
  </a>
</template>

<script>
import axios from "axios";

export default {
  props: {
    cardIndex: {
      type: Number,
      require: true,
    },
    title: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      require: false,
    },
  },
  methods: {
    // work around to download a file: create an anchor element with a download attribute and simulate a click
    download: function (path, fileName) {
      const anchor = document.createElement("a");
      // console.log(anchor);
      anchor.href = path;
      anchor.target = "_blank";
      anchor.download = fileName;
      anchor.click();
      anchor.remove();
    },
    forceFileDownload (response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios (url, title) {
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
  },
  computed: {
    imagePath () {
      return "./img/" + this.image;
    },
    classString () {
      return ` nav-link ${this.isActive ? " active show" : ""}`;
    },
  },
};
</script>
